// Mutable state for logging configuration
let _cacheLoggingEnabled = false
let _logLevel = 'info'

/**
 * Get or set the log level
 * @param {string} [value] - Optional value to set
 * @returns {string} - Current log level
 */
function LogLevel(value) {
  if (value !== undefined) {
    _logLevel = value
    console.log(`[LogConfig] Log level set to: ${_logLevel}`)
  }

  return _logLevel
}

/**
 * Get or set cache logging enabled state
 * @param {boolean} [value] - Optional value to set (true to enable, false to disable)
 * @returns {boolean} - Current cache logging state
 */
function CacheLogging(value) {
  if (value !== undefined) {
    _cacheLoggingEnabled = !!value
    console.log(`[LogConfig] Cache logging ${_cacheLoggingEnabled ? 'ENABLED' : 'DISABLED'}`)
  }

  return _cacheLoggingEnabled
}

export const LogConfig = () => {
  return {
    LogLevel,
    CacheLogging,
  }
}

// Expose LogConfig to window for console access
// This allows developers to enable cache logging from the browser console
// Usage: LogConfig().CacheLogging(true)
if (typeof window !== 'undefined') {
  window.LogConfig = LogConfig
}
